/* eslint-disable max-len */
import { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Dialog,
  DialogTitle,
  FormControlLabel,
  Paper,
  Radio,
  RadioGroup,
  Grid,
  TextField,
  Button,
  FormGroup,
  Checkbox,
  FormControl,
  FormLabel,
} from '@mui/material';
import useProjects from '../data/useProjects';
import useAuthContext from '../auth/useAuthContext';
import useUser from '../data/useUser';
import config from '../config';

function ProjectSelectEdit({
  open, handleClose, projects, currentProject, setCurrentProject,
}) {
  const initLanguages = config.languages;
  const { user } = useAuthContext();
  const { updateProject } = useProjects({ user });
  const [projectId, setProjectId] = useState(currentProject?.project || null);
  const [openNewDialog, setOpenNewDialog] = useState(false);
  const [description, setDescription] = useState('');
  const [languages, setLanguages] = useState();
  const [defaultLang, setDefaultLang] = useState();
  const [newlanguages, setnewLanguages] = useState(); // new state variable
  const [newLangs, setnewLangs] = useState();
  const [newtt, setNewtt] = useState();
  const handleNewDialogClose = () => {
    setOpenNewDialog(false);
  };
  const { updateUser } = useUser({ user });

  console.log(newtt);
  console.log(projects);
  console.debug(`User: ${user}`);
  const handleSubmit = async () => {
    console.log(currentProject, description);
    // const enabledLanguages = languages.filter((language) => language.enabled);
    // console.log(enabledLanguages);
    const uniqueLanguages = Array.from(new Set(languages.map((lang) => JSON.stringify(lang)))).map((lang) => JSON.parse(lang));
    console.log(languages);
    await updateProject(currentProject, {
      description,
      languages: uniqueLanguages,
      defaultLang,
    });
    handleNewDialogClose();
    window.location.reload();
  };
  const handleOpenDialog = () => {
    setOpenNewDialog(true);
  };

  const handleProjectChange = (event) => {
    setnewLangs(null);
    console.log('newlanguages', newLangs);
    const projectid = event.target.value;
    const project = projects.find((p) => p.project === projectid);
    setDescription(project.description);
    if (project) {
      setCurrentProject(project.project);
      setLanguages(project.languages);
      setnewLanguages(initLanguages.filter((language) => project.languages && !project.languages.some((lang) => lang.code === language.code)));
      setProjectId(projectid);
      updateUser({
        currentProject: project.project,
      });
      setDefaultLang(project.defaultLang);
      const newInitLanguages = initLanguages.map((initLang) => {
        const lang = project.languages && project.languages.find((l) => l.code === initLang.code);
        if (lang) {
          return { ...initLang, enabled: true };
        }
        return initLang;
      });

      setnewLanguages(newInitLanguages);
      setnewLangs(JSON.parse(JSON.stringify(newInitLanguages)));
      console.log('new languages', newLangs);
      setProjectId(null);
      handleClose();
      handleOpenDialog();
      // event.preventDefault();
    } else {
      console.error(`Could not find project with id ${projectId}`);
      setCurrentProject(null);
      setProjectId(null);
    }
    handleClose();
  };
  return (
    <>
      <Dialog open={open} onClose={handleClose}>

        <DialogTitle>Edit Project</DialogTitle>
        <Box
          sx={{
            width: '100%',
            m: 1,
          }}
        >
          <Paper elevation={0}>
            {projects && projects.length > 0 ? (
              <RadioGroup value={projectId} onChange={handleProjectChange}>
                {projects
                && projects.map((project) => (
                  <FormControlLabel
                    value={project.project}
                    key={project.project + project.user}
                    control={<Radio />}
                    label={project.project}
                  />
                ))}
              </RadioGroup>
            ) : (
              <p>No projects to show.</p>
            )}
          </Paper>
        </Box>
      </Dialog>
      <Dialog open={openNewDialog} onClose={handleNewDialogClose}>
        <DialogTitle>Edit Project</DialogTitle>
        <Box
          sx={{
            width: '90%',
            m: 1,
          }}
        >
          <Paper elevation={0}>
            <Grid
              container
              direction='row'
              spacing={2}
            >
              <Grid item xs={4}>
                {/* <TextField
                sx={{ py: 1 }}
                size='small'
                label='Project Name'
                value={projectId}
                onChange={(e) => setProjectId(e.target.value)}
              /> */}
                <TextField
                  sx={{ py: 1 }}
                  size='small'
                  fullWidth
                  label='New Description'
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                />
                <Button variant='contained' type='submit' onClick={handleSubmit}>
                  Submit
                </Button>
              </Grid>
              <Grid item xs={5}>
                <FormGroup>
                  {newlanguages && newlanguages
                    .map((language, index) => (
                      <FormControlLabel
                        key={language.name}
                        control={(
                          <Checkbox
                            defaultChecked={language.enabled}
                            disabled={newLangs[index].name === defaultLang.name}
                            onChange={(event) => {
                              newLangs[index].enabled = event.target.checked;
                              if (!event.target.checked && defaultLang.name !== newLangs[index].name) {
                                newLangs[index].enabled = false; // set enabled to false if unchecked
                              }
                              console.log('newlangs', newLangs);
                              console.log('newlanguages', newlanguages);
                              const newt = newLangs.filter((lang) => lang.enabled);
                              setNewtt(newt);
                              console.log(newt);
                              const allLanguages = [...newt];
                              const filteredLanguages = allLanguages.filter((lang) => lang.enabled);
                              setLanguages(filteredLanguages);
                            }}
                          />
)}
                        label={`${language.code} (${language.name})`}
                      />
                    ))}
                </FormGroup>
              </Grid>
              <Grid item xs={2}>
                <FormControl>
                  <FormLabel id='demo-radio-buttons-group-label'>Defalt language</FormLabel>
                  <RadioGroup
                    aria-labelledby='demo-radio-buttons-group-label'
                    defaultValue='female'
                    name='radio-buttons-group'
                  >
                    {languages && languages.map((language) => (
                      <FormControlLabel
                        checked={defaultLang.name === language.name}
                        key={language.name}
                        value={language}
                        control={<Radio />}
                        onChange={() => setDefaultLang(language)}
                        label={`${language.code} (${language.name})`}
                      />
                    ))}
                  </RadioGroup>
                </FormControl>
              </Grid>
            </Grid>
          </Paper>
        </Box>
      </Dialog>
    </>
  );
}

ProjectSelectEdit.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  setCurrentProject: PropTypes.func,
  currentProject: PropTypes.string,
  projects: PropTypes.arrayOf(
    PropTypes.shape({
      project: PropTypes.string,
      user: PropTypes.string,
      description: PropTypes.string,
      languages: PropTypes.arrayOf(
        PropTypes.shape({
          name: PropTypes.string,
          code: PropTypes.string,
        }),
      ),
    }),
  ),
};

ProjectSelectEdit.defaultProps = {
  open: false,
  handleClose: () => {},
  setCurrentProject: () => {},
  currentProject: '',
  projects: [],
};

export default ProjectSelectEdit;
